module.exports = __webpack_public_path__ + "img/pdf.7ded6365.svg";